import React from 'react'

export default function WorkExperienceSection(props) {
    return (
        <div className="work-experience">
            <h5 className="accent-color upper-case">{props.title}</h5>
            {props.projectName?<p className="low-contrast-color semi-bold project-title ">Project: {props.projectName}</p>:null}
            <p className="low-contrast-color semi-bold project-title">Duration: {props.duration}</p>
            <ul className="work-experience-points">{
                props.pointsArray.map((point)=>{
                    return (
                        <li className="low-contrast-color">{point}</li>
                    )
                })
            }</ul>
            
        </div>
    )
}
